export const rem = (px: number) => (px / 16).toFixed(3) + 'rem';
